import { Dayjs } from "dayjs";
import { UnauthorizedUsageResponse } from "../models/unauthorizedUsage.model";

export interface UnauthorizedUsageInitialState {
    data: UnauthorizedUsageResponse[];
    companies: string[];
    departments: string[];
    forklifts: string[];
    showFilters: boolean;
    startDate: Dayjs | null;
    endDate: Dayjs | null;
}

const unauthorizedUsageInitialState: UnauthorizedUsageInitialState = {
    data: [],
    companies: [],
    departments: [],
    forklifts: [],
    showFilters: true,
    startDate: null,
    endDate: null,
};

export default unauthorizedUsageInitialState;
